import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

import Logo from '@/assets/logo.svg';

export default {
  data() {
    return {
      countryStateProvince: [],
    };
  },
  computed: {
    pictureUrl(picture) {
      return `data:${picture.MimeType};base64,${picture.PictureBinary}`;
    },
    ...mapGetters({
      config: 'core/config',
      storeConfig: 'core/storeConfig',
      countries: 'core/countries',
      stateProvince: 'core/stateProvince',
      warehouses: 'core/warehouses',
      languages: 'core/languages',
      currencies: 'core/currencies',
      stores: 'core/stores',
      store: 'core/store',
    }),
  },
  methods: {
    currencyFormatter(locale = 'pl-Pl', currency = 'PLN') {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      });
    },
    dateFormatter(locale) {
      return new Intl.DateTimeFormat(locale || this.$i18n.locale);
    },
    warehouseName(Id) {
      const warehouseData = _.find(this.warehouses, { Id });
      return warehouseData ? warehouseData.Name : Id;
    },
    filterStateProvince(CountryId) {
      return this.stateProvince.filter((state) => state.CountryId === CountryId);
    },
    getCountryAndStateToName(collectionName, id) {
      const data = _.find(this[collectionName], (item) => item.Id === id);
      return data ? data.Name : id;
    },
    pictureUrlPath(path) {
      return this.config.global.imageBaseUrl + path;
    },
    getLogo() {
      const logoPath = this.storeConfig?.general?.logo;
      return logoPath ? this.pictureUrlPath(logoPath) : Logo;
    },
    headerTitle() {
      return this.storeConfig?.seo?.defaultTitle || 'BMW';
    },
    ...mapActions({
      fetchCountries: 'core/fetchCountries',
      fetchStateProvince: 'core/fetchStateProvince',
      fetchWarehouses: 'core/fetchWarehouses',
      fetchLanguages: 'core/fetchLanguages',
      fetchCurrencies: 'core/fetchCurrencies',
      fetchStores: 'core/fetchStores',
      fetchCurrentStore: 'core/fetchCurrentStore',
      fetchPicture: 'core/fetchPicture',
    }),
  },
};
